module.exports = __webpack_public_path__ + "static/media/tal-short.f32ba578.svg";